import React from 'react';
import PropTypes from 'prop-types';
import { Hide, ShimmerAvatar, ShimmerTypography } from '@pitchero/react-ui';

const TableLoadingStateRow = ({ columns }) => {
  const renderAdditionalColumns = () => {
    const placeholders = [];
    for (let i = 1; i <= columns; i += 1) {
      placeholders.push(
        <Hide maxWidth="tab" key={i}>
          <ShimmerTypography />
        </Hide>,
      );
    }
    return placeholders;
  };

  return (
    <>
      <ShimmerTypography />
      <ShimmerAvatar size={32} style={{ justifySelf: 'center' }} />
      <ShimmerTypography />
      {renderAdditionalColumns()}
    </>
  );
};

TableLoadingStateRow.propTypes = {
  columns: PropTypes.number.isRequired,
};

export default TableLoadingStateRow;
